/** Regex to detect profile GET/PATCH URLs so adapters can map response to MyProfile. */
export const MY_PROFILE_URL_REGEX = /^\/app\/v2\/users\/\d+\/$/

export const USER_ENDPOINTS = {
  // Global user endpoints
  GLOBAL_LIST: () => `/app/v2/users/`,
  DETAIL: (userId: number) => `/app/v2/users/${userId}/`,
  USER_ROLES: (userId: number) => `/users/${userId}/roles/`,
  USER_PBXES: (userId: number) => `/app/v2/users/${userId}/pbxes/`,
  CREATE: () => `/app/v2/users/`,
  UPDATE: (userId: number) => `/app/v2/users/${userId}/`,
  ROLES: () => `/app/v1/roles/`,

  // PBX-scoped user endpoints
  /** @deprecated Use PBX_LIST. Kept for backwards compatibility. */
  LIST: (pbxId: number) => `/app/v1/pbxes/${pbxId}/users/`,
  PBX_LIST: (pbxId: number) => `/app/v1/pbxes/${pbxId}/users/`,
  ADD_TO_PBX: (pbxId: number) => `/app/v1/pbxes/${pbxId}/users/`,
  UPDATE_PBX_USER: (pbxId: number, userId: number) =>
    `/app/v1/pbxes/${pbxId}/users/${userId}/`,
  REMOVE_FROM_PBX: (pbxId: number, userId: number) =>
    `/app/v1/pbxes/${pbxId}/users/${userId}/`,
  /** Get current user profile for My Profile modal (backend: GET /app/v2/users/{id}/) */
  MY_PROFILE: (userId: number) => `/app/v2/users/${userId}/`,
  /** Update my profile - first/last only (backend: PATCH /app/v2/users/{id}/) */
  UPDATE_MY_PROFILE: (userId: number) => `/app/v2/users/${userId}/`,
  /** Generate a password-reset link for a user (GET /app/v2/users/{id}/reset-password/) */
  RESET_PASSWORD: (userId: number) => `/app/v2/users/${userId}/reset-password/`,
} as const

export const USER_QUERY_KEYS = {
  all: ['users'] as const,
  lists: () => [...USER_QUERY_KEYS.all, 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...USER_QUERY_KEYS.lists(), params] as const,
  globalLists: () => [...USER_QUERY_KEYS.all, 'globalList'] as const,
  globalList: (params: Record<string, unknown>) =>
    [...USER_QUERY_KEYS.globalLists(), params] as const,
  details: () => [...USER_QUERY_KEYS.all, 'detail'] as const,
  detail: (id: number) => [...USER_QUERY_KEYS.details(), id] as const,
  assignedRoles: (userId: number) =>
    [...USER_QUERY_KEYS.all, 'assignedRoles', userId] as const,
  userPbxLists: () => [...USER_QUERY_KEYS.all, 'userPbxList'] as const,
  userPbxList: (userId: number) =>
    [...USER_QUERY_KEYS.userPbxLists(), userId] as const,
  roles: () => [...USER_QUERY_KEYS.all, 'roles'] as const,
  /** Profile is user-scoped; key by userId only to avoid pointless refetches when pbxId changes. */
  myProfile: (userId: number) =>
    [...USER_QUERY_KEYS.all, 'myProfile', userId] as const,
} as const
